// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__35D9W","col":"Table_col__b9fov","fulfillmentStatus":"Table_fulfillmentStatus__1Knu3","emailCol":"Table_emailCol__2qu9s"};